import React, { useState } from "react";
import { JsonEditor } from "json-edit-react";
import { spacing } from "../../../../../../stitches.config";
import { FlexColumn } from "../../../../../Common/__styles__/Layout";
import { Button } from "../../../../../Common/Buttons/Button";
import { Body, Title } from "../../../../../Common/Typography";
import Textarea from "../../../../../Inputs/Textarea";
import { useBuilderFormContext, useBuilderWatch } from "../form/form";

export function LogicRulesTab() {
  const { setValue } = useBuilderFormContext();

  const conditionalRules = useBuilderWatch("conditionalRules");
  const conditionalRulesUserPrompt = useBuilderWatch(
    "conditionalRulesUserPrompt",
  );

  const [userPrompt, setUserPrompt] = useState(
    conditionalRulesUserPrompt ?? "",
  );

  const handleGenerate = async () => {
    // TODO: Hook into conditional rules assistant API to get actual generated rules
    // For now, we just keep the existing rules as a placeholder
    const generatedRules = conditionalRules ?? [];

    setValue("conditionalRules", generatedRules, { shouldDirty: true });
    setValue("conditionalRulesUserPrompt", userPrompt, { shouldDirty: true });
  };

  return (
    <FlexColumn css={{ gap: spacing.l }}>
      <FlexColumn css={{ gap: spacing.s }}>
        <Title size="small" type="semiBold">
          Logic rules
        </Title>
        <Body size="default" type="regular" color="contentSecondary">
          Describe the conditional rules you'd like to set up in plain language
        </Body>
      </FlexColumn>

      <FlexColumn css={{ gap: spacing.s }}>
        <Textarea
          name="conditionalRulesPrompt"
          value={userPrompt}
          onChange={setUserPrompt}
          minRows={4}
        />
        <Button title="Generate" size="small" onClick={handleGenerate} />
      </FlexColumn>

      <JsonEditor
        maxWidth="100%"
        restrictEdit={true}
        restrictAdd={true}
        restrictDelete={true}
        collapse={false}
        rootName=""
        data={conditionalRules ?? []}
      />
    </FlexColumn>
  );
}
